import React from 'react';
import img from '../../../Assets/people.webp';
import { Link } from 'react-router-dom';

const Profile = () => {
  return (
    <div className="flex flex-col items-center mt-10 py-10 bg-gradient-to-r from-[#1d2b0f] to-[#305301]">
      <div className="flex flex-col md:flex-row mt-5 items-center bg-white shadow-2xl rounded-3xl p-8 md:p-12 w-full max-w-6xl">
        <div className="flex flex-col items-center md:w-1/2">
          <div className="relative">
            <img
              src={img}
              alt="Profile"
              className="w-[20rem] h-[20rem] md:w-[25rem] md:h-[25rem] rounded-full object-cover border-8 border-white shadow-[0px_0px_25px_10px_#2E4F03]"
            />

          </div>
          <div className="flex flex-row gap-4 mt-6">
            <Link to="/contact">
              <button className="bg-yellow-500 text-white font-semibold py-2 px-4 rounded-lg shadow-lg hover:bg-yellow-600 transition duration-300">
                BRIDAL PACKAGE
              </button>
            </Link>

            <button className="bg-[#3a5a0f] text-white font-semibold py-2 px-4 rounded-lg shadow-lg hover:bg-blue-600 transition duration-300">
              <a href="tel:+917303572367" className="text-white">CLICK TO CALL</a>
            </button>
          </div>
        </div>
        <div className="md:w-1/2 mt-8 md:mt-0 md:ml-10">
          <h1 className="text-xl font-semibold text-gray-700">10+ Years of Experience</h1>
          <h2 className="text-3xl font-bold text-yellow-500 mt-4 font-roboto">Expert Mehandi Artist for Weddings, Festivals, and Celebrations</h2>
          <p className="text-gray-600 mt-4">
            Sumit is the best Mehandi artist in Delhi, renowned for bridal Mehandi artistry, and is highly sought after for various occasions. Our services are known for their
            high quality, creativity, and professionalism.
          </p>
          <p className="text-gray-600 mt-4">
            We bring a rich cultural heritage to life through our intricate Mehandi designs, admired globally. With years of experience, Sumit stands out as one of Delhi’s
            leading traditional Mehandi artists.
          </p>
          <p className="text-gray-600 mt-4">
            Mehandi is a vital part of Indian weddings and traditions. We offer a variety of Mehandi designs, including Bridal, Arabic, and heavy Mehandi, making us a top choice in Delhi.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
